import axiosInstance from 'api/axios';
import { APIResponse, GenerateSocialMediaRequest } from '../types';

export interface SocialMediaResponse {
  image_url: string;
  post: string;
}



export interface IUploadImageRequestPayload {

  file: FormData;
}

export interface GenerateSocialMediaImageRequest {
  query: string;
}

export interface GenerateTrendingRequest {
  domain: string;
  platform_key: string;
}

export interface ISocialMediaMetaTopics {
  id: string;
  platform_name: string;
  topic: string;
  sub_topics: string[];
  created_at: string;
}

export interface ISaveGenerationRequestPayload {
  post_topic: string;
  post_sub_topic: string;
  post_prompt: string;
  post_language: string;
  post_no_of_drafts: number;
  post_tone: string;
  post_name: string;
  post_content: string;
  img_url?: string;
  erase_img_after_publish?: boolean;
  platform_name: string;
}

// Update IUserPost interface to match the API response
export interface IUserPost {
  id: number;
  post_name: string;
  platform_name: string;  // Changed from 'platform'
  post_content: string;
  img_url: string;
  erase_img_after_publish: boolean;
  target_handle: string;
  status: 'saved' | 'published' | 'scheduled';
  published_at: string | null;
  scheduled_at: string | null;
  created_at: string;
  updated_at: string;
  user_id: string;
}

export const socialMediaService = {
  // Generate Social Media Post
  generatePost: async (
    data: GenerateSocialMediaRequest,
    signal?: AbortSignal
  ): Promise<APIResponse<SocialMediaResponse[]>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/generate',
      data,
      {
        signal,
      }
    );
    return response.data;
  },

  // Generate Social Media Image
  generateImage: async (
    data: GenerateSocialMediaImageRequest
  ): Promise<APIResponse<{ query: string }>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/image/generate',
      data
    );
    return response.data;
  },

  // Get Trending Topics
  getTrending: async (
    data: GenerateTrendingRequest
  ): Promise<APIResponse<{ query: string }>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/trending',
      data
    );
    return response.data;
  },

  getMetaTopics: async (): Promise<APIResponse<ISocialMediaMetaTopics[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/social-media/meta/topics'
    );
    return response.data;
  },

  // Upload Image
  uploadImage: async (
    data: IUploadImageRequestPayload
  ): Promise<APIResponse<{ query: string }>> => {
    const formData = data.file;

    const response = await axiosInstance.private.post(
      '/api/v1/social-media/image/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  // save-generation
  saveGeneration: async (
    data: ISaveGenerationRequestPayload
  ) => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/save',
      data
    );
    return response.data;
  },

  // Get User Posts
  getUserPosts: async (): Promise<APIResponse<IUserPost[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/social-media/user-posts'
    );
    return response.data;
  },

  // Delete User Post
  deletePostById: async (post_id: number): Promise<APIResponse<void>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/social-media/post/${post_id}`
    );
    return response.data;
  },
};

export default socialMediaService;
